export default "__VITE_ASSET__B0KIcXV7__"